export const polyfillBigInt = () => {
  // eslint-disable-next-line @typescript-eslint/no-redeclare,@typescript-eslint/no-unused-vars
  interface BigInt {
    /** Convert to BigInt to string form in JSON.stringify */
    toJSON: () => string;
  }
  // @ts-expect-error Polyfill method
  // eslint-disable-next-line no-extend-native
  BigInt.prototype.toJSON = function () {
    return this.toString();
  };
};
